import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { useFormatMoneda } from '../utils/moneda';

export default function Rutas() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const formatMoneda = useFormatMoneda();
  const [rutas, setRutas] = useState([]);
  const [cobradores, setCobradores] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [modal, setModal] = useState(false);
  const [detalle, setDetalle] = useState(null);
  const [form, setForm] = useState({ nombre: '', cobrador_id: '', zona: '', descripcion: '' });
  const [editId, setEditId] = useState(null);
  const [clienteAdd, setClienteAdd] = useState('');
  const [loading, setLoading] = useState(false);
  const [pendientesHoy, setPendientesHoy] = useState([]);

  function cargar() {
    api.get('/rutas').then(r => setRutas(r.data)).catch(() => {});
    api.get('/cobros/pendientes-hoy').then(r => setPendientesHoy(r.data)).catch(() => {});
    api.get('/clientes', { params: { activo: 1 } }).then(r => setClientes(r.data)).catch(() => {});
    if (usuario?.rol !== 'cobrador') {
      api.get('/usuarios', { params: { rol: 'cobrador' } }).then(r => setCobradores(r.data)).catch(() => {});
    }
  }

  useEffect(() => { cargar(); }, []);

  async function guardar(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await api.put(`/rutas/${editId}`, form);
        toast.success('Ruta actualizada');
      } else {
        await api.post('/rutas', form);
        toast.success('Ruta creada');
      }
      setModal(false);
      setForm({ nombre: '', cobrador_id: '', zona: '', descripcion: '' });
      setEditId(null);
      cargar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  }

  async function verDetalle(ruta_id) {
    try {
      const res = await api.get(`/rutas/${ruta_id}`);
      setDetalle(res.data);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error cargando ruta');
    }
  }

  async function agregarCliente() {
    if (!clienteAdd) return;
    try {
      await api.post(`/rutas/${detalle.id}/clientes`, { cliente_id: clienteAdd });
      toast.success('Cliente agregado');
      const res = await api.get(`/rutas/${detalle.id}`);
      setDetalle(res.data);
      setClienteAdd('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error');
    }
  }

  async function quitarCliente(cliente_id) {
    try {
      await api.delete(`/rutas/${detalle.id}/clientes/${cliente_id}`);
      const res = await api.get(`/rutas/${detalle.id}`);
      setDetalle(res.data);
      toast.success('Cliente removido');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al quitar cliente');
    }
  }

  const cobradosHoy = pendientesHoy.filter(p => p.cobrado_hoy > 0).length;
  const porCobrarHoy = pendientesHoy.filter(p => p.cobrado_hoy === 0).length;

  return (
    <div>
      <div style={styles.header}>
        <h2 style={styles.title}>Rutas de Cobro</h2>
        {usuario?.rol !== 'cobrador' && (
          <button style={styles.btnPrimary} onClick={() => { setForm({ nombre: '', cobrador_id: '', zona: '', descripcion: '' }); setEditId(null); setModal(true); }}>+ Nueva Ruta</button>
        )}
      </div>

      {/* Cobros de hoy */}
      {pendientesHoy.length > 0 && (
        <div style={{ marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
            <h3 style={{ margin: 0, color: 'var(--text-2)', fontSize: '0.85rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Cobros de hoy — {new Date().toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' })}
            </h3>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <span style={{ background: '#064e3b', color: '#4ade80', borderRadius: 999, padding: '2px 10px', fontSize: '0.78rem', fontWeight: 700 }}>{cobradosHoy} cobrados</span>
              <span style={{ background: '#450a0a', color: '#f87171', borderRadius: 999, padding: '2px 10px', fontSize: '0.78rem', fontWeight: 700 }}>{porCobrarHoy} pendientes</span>
            </div>
          </div>

          {/* Barra de progreso del día */}
          <div style={{ background: 'var(--bg-card)', borderRadius: 8, padding: '0.75rem 1rem', marginBottom: '0.75rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', color: 'var(--text-3)', marginBottom: 6 }}>
              <span>Progreso del día</span>
              <span>{pendientesHoy.length > 0 ? Math.round((cobradosHoy / pendientesHoy.length) * 100) : 0}%</span>
            </div>
            <div style={{ height: 8, background: 'var(--bg-app)', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{ width: `${pendientesHoy.length > 0 ? (cobradosHoy / pendientesHoy.length) * 100 : 0}%`, height: '100%', background: '#38bdf8', borderRadius: 4, transition: 'width 0.4s' }} />
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
            {pendientesHoy.map(p => (
              <div key={p.cuota_id} style={{ background: 'var(--bg-card)', borderRadius: 8, padding: '0.75rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: `3px solid ${p.cobrado_hoy > 0 ? '#4ade80' : '#f87171'}` }}>
                <div>
                  <span style={{ color: 'var(--text-1)', fontWeight: 600, fontSize: '0.9rem' }}>{p.cliente_nombre}</span>
                  <span style={{ color: 'var(--text-3)', fontSize: '0.78rem', marginLeft: 8 }}>{p.ruta_nombre}</span>
                  {p.cliente_telefono && (
                    <span style={{ color: 'var(--text-4)', fontSize: '0.78rem', marginLeft: 8 }}>· {p.cliente_telefono}</span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span style={{ color: p.cobrado_hoy > 0 ? '#4ade80' : '#f87171', fontWeight: 700, fontSize: '0.95rem' }}>
                    {formatMoneda(p.monto - p.monto_pagado)}
                  </span>
                  {p.cobrado_hoy > 0
                    ? <span style={{ background: '#064e3b', color: '#4ade80', borderRadius: 999, padding: '2px 8px', fontSize: '0.75rem', fontWeight: 700 }}>✓ Cobrado</span>
                    : (
                      <button
                        onClick={() => navigate(`/rutas/${p.ruta_id}/guia`)}
                        style={{ background: '#0c4a6e', color: '#38bdf8', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600 }}
                      >
                        Ir a ruta
                      </button>
                    )
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={styles.grid}>
        {rutas.map(r => (
          <div key={r.id} style={styles.card}>
            <div style={styles.cardHeader}>
              <h3 style={styles.cardTitle}>{r.nombre}</h3>
              <span style={{ ...styles.badge, background: r.activa ? '#064e3b' : '#7f1d1d', color: r.activa ? '#34d399' : '#f87171' }}>{r.activa ? 'Activa' : 'Inactiva'}</span>
            </div>
            <p style={styles.cardSub}>Cobrador: {r.cobrador_nombre || 'Sin asignar'}</p>
            <p style={styles.cardSub}>Zona: {r.zona || '-'} | Clientes: {r.total_clientes}</p>
            <div style={styles.cardActions}>
              <button style={{ ...styles.btnEdit, background: '#0c4a6e', color: '#38bdf8', fontWeight: 700 }} onClick={() => navigate(`/rutas/${r.id}/guia`)}>Iniciar Guía</button>
              <button style={styles.btnEdit} onClick={() => verDetalle(r.id)}>Editar clientes</button>
              <button style={styles.btnEdit} onClick={() => { setForm({ nombre: r.nombre, cobrador_id: r.cobrador_id || '', zona: r.zona || '', descripcion: r.descripcion || '' }); setEditId(r.id); setModal(true); }}>Editar</button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>{editId ? 'Editar Ruta' : 'Nueva Ruta'}</h3>
            <form onSubmit={guardar}>
              {[['nombre', 'Nombre de la ruta', 'text', true], ['zona', 'Zona', 'text', false], ['descripcion', 'Descripción', 'text', false]].map(([key, label, type, req]) => (
                <div key={key} style={styles.field}>
                  <label style={styles.label}>{label}</label>
                  <input type={type} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} required={req} style={styles.input} />
                </div>
              ))}
              <div style={styles.field}>
                <label style={styles.label}>Cobrador asignado</label>
                <select value={form.cobrador_id} onChange={e => setForm({ ...form, cobrador_id: e.target.value })} style={styles.input}>
                  <option value="">Sin asignar</option>
                  {cobradores.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
              <div style={styles.modalActions}>
                <button type="button" style={styles.btnCancel} onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" style={styles.btnPrimary} disabled={loading}>{loading ? 'Guardando...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {detalle && (
        <div style={styles.overlay}>
          <div style={{ ...styles.modal, maxWidth: '650px' }}>
            <h3 style={styles.modalTitle}>Ruta: {detalle.nombre}</h3>
            <p style={{ color: 'var(--text-2)', marginTop: 0 }}>Cobrador: {detalle.cobrador_nombre || 'Sin asignar'} | Zona: {detalle.zona || '-'}</p>
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
              <select value={clienteAdd} onChange={e => setClienteAdd(e.target.value)} style={{ ...styles.input, flex: 1 }}>
                <option value="">Agregar cliente a ruta...</option>
                {clientes.filter(c => !detalle.clientes.find(rc => rc.id === c.id)).map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
              </select>
              <button style={styles.btnPrimary} onClick={agregarCliente}>Agregar</button>
            </div>
            <table style={styles.table}>
              <thead><tr style={styles.thead}><th>#</th><th>Cliente</th><th>Saldo Pend.</th><th>Cuotas Venc.</th><th></th></tr></thead>
              <tbody>
                {detalle.clientes.map((c, i) => (
                  <tr key={c.id} style={styles.row}>
                    <td>{i + 1}</td>
                    <td>{c.nombre}</td>
                    <td>{formatMoneda(c.saldo_pendiente || 0)}</td>
                    <td style={{ color: c.cuotas_vencidas > 0 ? '#f87171' : '#94a3b8' }}>{c.cuotas_vencidas || 0}</td>
                    <td><button style={styles.btnDel} onClick={() => quitarCliente(c.id)}>Quitar</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {detalle.clientes.length === 0 && <p style={styles.empty}>Sin clientes en esta ruta</p>}
            <div style={styles.modalActions}>
              <button style={styles.btnCancel} onClick={() => setDetalle(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  title: { margin: 0, color: 'var(--text-1)', fontSize: '1.5rem' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' },
  card: { background: 'var(--bg-card)', borderRadius: '10px', padding: '1.25rem' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' },
  cardTitle: { margin: 0, color: 'var(--text-1)', fontSize: '1rem' },
  cardSub: { margin: '0.25rem 0', color: 'var(--text-2)', fontSize: '0.85rem' },
  cardActions: { display: 'flex', gap: '0.5rem', marginTop: '1rem' },
  badge: { borderRadius: '20px', padding: '0.2rem 0.7rem', fontSize: '0.75rem', fontWeight: 600 },
  btnPrimary: { background: '#38bdf8', color: '#0f172a', border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', fontWeight: 700, cursor: 'pointer' },
  btnEdit: { background: 'var(--bg-hover)', color: '#38bdf8', border: 'none', borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', fontSize: '0.8rem' },
  btnDel: { background: '#7f1d1d', color: '#fca5a5', border: 'none', borderRadius: '6px', padding: '0.3rem 0.7rem', cursor: 'pointer', fontSize: '0.8rem' },
  btnCancel: { background: 'var(--bg-hover)', color: 'var(--text-1)', border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: 'var(--bg-app)', color: 'var(--text-2)', textAlign: 'left', fontSize: '0.8rem' },
  row: { borderBottom: '1px solid var(--border)', color: 'var(--text-1s)', fontSize: '0.9rem' },
  empty: { textAlign: 'center', color: 'var(--text-3)', padding: '1.5rem' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 },
  modal: { background: 'var(--bg-card)', borderRadius: '12px', padding: '2rem', width: '100%', maxWidth: '480px', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { margin: '0 0 1rem', color: 'var(--text-1)' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.5rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', color: 'var(--text-2)', fontSize: '0.85rem', marginBottom: '0.3rem' },
  input: { width: '100%', padding: '0.65rem', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1)', fontSize: '0.95rem', boxSizing: 'border-box' }
};
